<template>
  <div>
    <section class="back-section">
      <div class="back-section__container">
        <ag-grid-vue
          @grid-ready="onGridReady"
          rowSelection="multiple"
          style="height: 500px;"
          class="ag-theme-alpine"
          enableSorting="true"
          enableFilter="true"
          enableColResize="true"
          pagination="true"
          paginationAutoPageSize="true"
          groupUseEntireRow="true"
          :rowData="rowData"
          :columnDefs="columnDefs"
          :localeText="localeText"
          :gridOptions="gridOptions"
          :enterMovesDownAfterEdit="true"
        >
        </ag-grid-vue>
      </div>
      <OrderCard
        :insideOpen="open"
        :insideOrderCardData="orderCardData"
        @openCardHandler="openCardHandler"
      ></OrderCard>
    </section>
  </div>
</template>

<script>
import ordersRequest from '@/assets/js/api/back/apiOrder';
import { mapState } from 'vuex';
import OrderEditButton from './components/OrderEditButton.vue';
import OrderCard from './components/OrderCard.vue';

export default {
  created() {
    ordersRequest.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
  },
  beforeMount() {
    // 初始化
    // 允許父通信 表格要加上:gridOptions="gridOptions"
    this.gridOptions = {
      context: {
        componentParent: this,
      },
    };
    // 中文化
    this.localeText = this.$localText;
    // 行資料
    this.createRowData();
    // 列資料
    this.createColumnDefs();
  },
  components: { OrderEditButton, OrderCard },
  data() {
    return {
      open: false,
      orderCardData: [],
      //ag
      columnDefs: '',
      rowData: '',
      gridApi: null,
      columnApi: null,
      context: null,
      gridOptions: null,
      // 默認預言設定
      localeText: {},
    };
  },
  computed: {
    ...mapState({
      user: 'user',
    }),

    couponFormData() {
      return {
        title: this.title,
        code: this.code,
        percent: this.percent,
        enabled: this.enabled,
        deadline_at: this.deadline_at,
      };
    },
  },
  methods: {
    openCardHandler(bollean, data) {
      this.open = bollean;
      if (bollean) {
        this.orderCardData = data.products;
      } else {
        this.orderCardData = [];
      }
    },
    //-----------------------------------------------------------以下是ag功能
    onGridReady(params) {
      // 獲取aggrid.api物件才能使用裡面的方法 例如自動縮放 單元格子獲取
      this.gridApi = params.api;
      // 忘了
      this.columnApi = params.columnApi;
      // 設定自動填滿
      this.gridApi.sizeColumnsToFit();
    },
    createRowData() {
      //預設帶入 token
      ordersRequest.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
      ordersRequest.get('').then(response => {
        response.data.data.forEach(item => {
          if (item.coupon === null) {
            item.coupon = { code: '未使用' };
          }
        });
        this.rowData = response.data.data;
      });
    },
    createColumnDefs() {
      // 表格要加上:columnDefs="columnDefs"
      this.columnDefs = [
        {
          headerName: '訂單編號',
          field: 'id', // 單選
          minWidth: 50,
          menuTabs: ['filterMenuTab', 'columnsMenuTab'],
        },
        {
          headerName: '付款時間',
          field: 'paid_at', // 單選
          minWidth: 100,
          menuTabs: ['filterMenuTab', 'columnsMenuTab'],
        },
        {
          headerName: '付款狀態',
          field: 'paid',
          menuTabs: ['filterMenuTab'],
        },
        {
          headerName: '付款方式',
          field: 'payment',
          menuTabs: ['filterMenuTab'],
        },
        {
          headerName: '付款金額',

          field: 'amount',
          menuTabs: ['filterMenuTab'],
        },
        {
          headerName: '使用優惠碼',
          field: 'coupon.code',
          menuTabs: ['filterMenuTab'],
        },
        {
          headerName: '查看商品',
          field: 'edit',
          minWidth: 200,
          colId: 'cube',
          pinned: 'right',
          cellRendererFramework: 'OrderEditButton',
          menuTabs: ['filterMenuTab'],
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped></style>
